@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Virginia</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!--Level One Selection -->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === '',
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Level Two Selection -->
      <div [ngClass]="baseRules?.shouldShowCoverageLabel !== false ? '_ml-xlarge' : ''">
        @if (controls?.length >= 2) {
          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required':
                reactiveForm.get(controls[1].formControlName)?.value === null ||
                reactiveForm.get(controls[1].formControlName)?.value === '',
              'has-axis-error':
                reactiveForm.get(controls[1].formControlName)?.touched &&
                reactiveForm.get(controls[1].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
              @for (control of controls[1].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[1].formControlName }}"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
            @if (baseRules?.Select_medicalExpenseBenefits_Radio === "Yes") {
              <div class="axis-col-12">
                <div class="axis-form-group _mt-medium">
                  <label
                    class="axis-control-label"
                    id="select_medicalexpensebenefits_radio-pdffield-virginia"
                  >
                    {{ textValues.Select_MedicalExpenseLimit_Text }}
                  </label>
                </div>
              </div>
            }
            <!-- Dropdown that relates to the second radio wrapper -->
            @if (controls[3] && baseRules[controls[3].baseRuleKey]?.includes("show")) {
              <div class="axis-col-sm-6 axis-col-md-4">
                <div
                  class="axis-form-group _mt-medium"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(controls[3].formControlName)?.value === null ||
                      reactiveForm.get(controls[3].formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(controls[3].formControlName)?.touched &&
                      reactiveForm.get(controls[3].formControlName)?.invalid,
                  }"
                >
                  <axis-dropdown
                    [dataProvider]="controls[3].data"
                    id="{{ controls[3].formControlName }}"
                    formControlName="{{ controls[3].formControlName }}"
                    (onSelect)="controls[3].selectedPremium = $any($event).premium"
                  ></axis-dropdown>
                  @if (reactiveForm.get(controls[3].formControlName)?.touched) {
                    @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    }
                  }

                  @if (controls[3].selectedPremium) {
                    <div [hidden]="!showPremium">Premium: {{ controls[3].selectedPremium }}</div>
                  }
                </div>
              </div>
            }

            @if (baseRules?.SelectMinincomeLossBenefits_DropDown === "Yes") {
              <!-- Display control label -->
              @if (controls?.[7]?.label) {
                <div class="axis-col-12">
                  <div class="axis-form-group _mt-medium">
                    <label
                      class="axis-control-label"
                      id="selectminincomelossbenefits_Yes-pdffield-virginia"
                    >
                      {{ controls[7].label }}
                    </label>
                  </div>
                </div>
              }
            }
          </div>

          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required':
                reactiveForm.get(controls[2].formControlName)?.value === null ||
                reactiveForm.get(controls[2].formControlName)?.value === '',
              'has-axis-error':
                reactiveForm.get(controls[2].formControlName)?.touched &&
                reactiveForm.get(controls[2].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
              @for (control of controls[2].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[2].formControlName }}"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[2].formControlName)?.touched) {
              @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Virginia</h2>
  <!--Reject All-->
  @if (baseRules?.Reject_LevelOne_Radio === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_LevelTwoMedical_Text }}
      </label>
      <label class="axis-control-label">
        {{ textValues?.Reject_LevelTwoIncome_Text }}
      </label>
    </div>
  }
  <!-- Select Min Medical Expense-->
  <div class="axis-grid">
    @if (baseRules?.SelectMinmedicalExpenseLimit_DropDown === "Yes") {
      <!-- Display control label -->
      @if (controls?.[6]?.label) {
        <div class="axis-col-12">
          <div class="axis-form-group _mt-medium _nmb">
            <label class="axis-control-label">
              {{ controls[6].label }}
            </label>
          </div>
        </div>

        <!-- Display option details -->
        @if (controls[6].data[0]["name"]) {
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group _nmt">
              <div>{{ controls[6].data[0]["name"] }}</div>
            </div>
          </div>

          @if (controls[6].data[0]["premium"]) {
            <div
              class="axis-col-sm-6 axis-col-md-4"
              [hidden]="!showPremium"
            >
              <div class="axis-form-group _mt-medium">
                <div>Premium: {{ controls[6].data[0]["premium"] }}</div>
              </div>
            </div>
          }
        }
      }
    }
  </div>
  <!-- Select Max Medical Expense-->
  <div class="axis-grid">
    @if (baseRules?.SelectMaxmedicalExpenseLimit_DropDown === "Yes") {
      <!-- Display control label -->
      @if (controls?.[5]?.label) {
        <div class="axis-col-12">
          <div class="axis-form-group _mt-medium _nmb">
            <label class="axis-control-label">
              {{ controls[5].label }}
            </label>
          </div>
        </div>

        <!-- Display option details -->
        @if (controls[5].data[0]["name"]) {
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group _nmt">
              <div>{{ controls[5].data[0]["name"] }}</div>
            </div>
          </div>

          @if (controls[5].data[0]["premium"]) {
            <div
              class="axis-col-sm-6 axis-col-md-4"
              [hidden]="!showPremium"
            >
              <div class="axis-form-group _mt-medium">
                <div>Premium: {{ controls[5].data[0]["premium"] }}</div>
              </div>
            </div>
          }
        }
      }
    }
  </div>
  <!-- Select Min Income benefit-->
  <div class="axis-grid">
    @if (baseRules?.SelectMinincomeLossBenefits_DropDown === "Yes") {
      <!-- Display control label -->
      @if (controls?.[7]?.label) {
        <div class="axis-col-12">
          <div class="axis-form-group _nmt">
            <label class="axis-control-label">
              {{ controls[7].label }}
            </label>
          </div>
        </div>
      }
    }
  </div>
}
